import React, {
  useState,
  useContext,
  useEffect,
  useCallback,
  Fragment,
} from "react";
import { JOB_TYPE } from "utils/constants";
import { Button, Divider, Empty, Modal } from "antd";
import { MainStore } from "core/store";
import FooterMenu from "components/footer-menu";
import ComingSoon from "components/coming-soon";
import JobCard from "./jobCard";
import AlertError from "containers/profile/alert-error";
import { useSearchParams } from "react-router-dom";
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import "./style.css";
import TextArea from "antd/es/input/TextArea";
import api from "api";
import Loading from "components/loading";
import liff from "@line/liff";
import dayjs from "dayjs";

const golfer_deduct_money = 0;

export default function CaddyJob({ is_comming, tab = null }) {
  const { userData } = useContext(MainStore);
  const [isLoading, setIsLoading] = useState(false);

  const [isClosed, setIsClosed] = useState(false);
  const [searchParams] = useSearchParams();
  const [isDelete, setIsDelete] = useState(false);
  const [deleteData, setDeleteData] = useState([]);
  const [menuActive, setMenuActive] = useState(
    tab ? tab : searchParams.get("tab") ? 1 : userData?.user_type === 0 ? 1 : 0
  );
  const [menuActiveKey, setMenuActiveKey] = useState(
    tab
      ? "upcomming"
      : searchParams.get("tab")
      ? searchParams.get("tab")
      : userData?.user_type === 0
      ? "upcomming"
      : "pending"
  );
  const [bookList, setBookList] = useState([]);
  const [isAcceptOrReject, setIsAcceptOrReject] = useState(false);
  const [bookingToAcceptOrReject, setBookingToAcceptOrReject] = useState(false);
  const [rejectRemark, setRejectRemark] = useState(null);

  const userType = userData.user_type;
  const userId = userData.user_id;

  function onChangePage(page_index, key) {
    setMenuActive(page_index);
    setMenuActiveKey(key);
  }

  useEffect(() => {
    GetBookingList();
  }, []);

  const calculateDeductMoney = useCallback((data) => {
    return data.grand_total - data.transaction_fee - data.vat;
  }, []);

  const GetBookingList = useCallback(async () => {
    try {
      setIsLoading(true);
      const { data } = await api.bookingApi.getBookingList({
        user_id: userId,
        user_type: userType,
      });
      setBookList(data.data);
    } catch (error) {
      console.error("Error setting loading state:", error);
    } finally {
      setIsLoading(false);
    }
  }, [userId, userType]);

  function onClickDelete(is_clear_all_history = false, delete_data = null) {
    setIsDelete(true);

    if (!is_clear_all_history) {
      setDeleteData(delete_data);
    } else {
      let delete_list = [];

      bookList?.history?.forEach((book) => {
        delete_list.push(book.id);
      });

      setDeleteData(delete_list);
    }
  }

  const onConfirmDelete = useCallback(async () => {
    setIsLoading(true);

    try {
      await api.bookingApi.deleteHistory({ delete_list: deleteData });
      setIsDelete(false);
      GetBookingList();
    } catch (error) {
      console.error("Error deleting history:", error);
    } finally {
      setIsLoading(false);
      setIsDelete(false);
    }
  }, [deleteData, GetBookingList]);

  const handeClickCancelJob = useCallback(
    async (job_data) => {
      let deduct_money = job_data.grand_total;
      let refund_amount = deduct_money > 0 ? deduct_money : 0;
      setIsLoading(true);

      try {
        await api.bookingApi.cancelJob({
          booking_id: job_data.id,
          is_from_golfer: parseInt(userType) === 0 ? false : true,
          refund_amount: Number((refund_amount ?? 0).toFixed(2)),
        });
      } catch (error) {
        console.error("Error cancelling job:", error);
      } finally {
        setIsLoading(false);
        GetBookingList();
      }
    },
    [GetBookingList, userType, calculateDeductMoney]
  );

  const onAcceptOrRejectBooking = useCallback(async () => {
    setIsLoading(true);
    try {
      liff.sendMessages([
        {
          type: "text",
          text: "สถานะการจอง: " + (bookingToAcceptOrReject.is_accept ? "รับงาน" : "ปฏิเสธงาน") + "\n" +
            "ผู้จอง: " + (bookingToAcceptOrReject.data.data?.user?.display_name || "ไม่ระบุ") + "\n" +
            "หมายเหตุ: " + (rejectRemark || bookingToAcceptOrReject.rejectRemark || "-") + "\n" +
            "รหัสการจอง: " + bookingToAcceptOrReject.data.booking_ref + "\n" +
            "วันที่ทีออฟ: " + dayjs(bookingToAcceptOrReject.data.tf_date).format("DD/MM/YYYY") + "\n" +
            "เวลาทีออฟ: " + dayjs(bookingToAcceptOrReject.data.tf_time).format("HH:mm") 
        }
      ]);
      await api.bookingApi.acceptORRejectBooking(
        bookingToAcceptOrReject.data.id,
        {
          is_accept: bookingToAcceptOrReject.is_accept,
          remark: rejectRemark,
        }
      );
    } catch (error) {
      console.error("Error in accept or reject booking:", error);
    } finally {
      setIsAcceptOrReject(false);
      setBookingToAcceptOrReject(null);
      setRejectRemark(null);
      setIsLoading(false);
      GetBookingList();
    }
  }, [bookingToAcceptOrReject, rejectRemark, GetBookingList]);

  return !is_comming || is_comming === "false" ? (
    <ComingSoon />
  ) : (
    <div className="job-container">
      <Loading visible={isLoading} />
      <Modal
        open={isAcceptOrReject}
        onCancel={() => {
          setIsAcceptOrReject(false);
          setBookingToAcceptOrReject(null);
          setRejectRemark(null);
        }}
        centered
        footer={false}
      >
        <div
          style={{
            display: "flex",
            gap: 10,
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {bookingToAcceptOrReject?.is_accept ? (
            <CheckCircleOutlined style={{ fontSize: 32, color: "green" }} />
          ) : (
            <CloseCircleOutlined style={{ fontSize: 32, color: "red" }} />
          )}
          <div style={{ fontSize: 18 }}>
            {bookingToAcceptOrReject?.is_accept ? (
              <div>
                ยืนยัน<span style={{ color: "green" }}> การรับงาน </span>ของ{" "}
                {bookingToAcceptOrReject?.data?.data?.user?.display_name}
              </div>
            ) : (
              <div>
                ปฏิเสธ<span style={{ color: "red" }}> การรับงาน </span>ของ{" "}
                {bookingToAcceptOrReject?.data?.data?.user?.display_name}
              </div>
            )}
          </div>
        </div>
        {!bookingToAcceptOrReject?.is_accept && (
          <div style={{ marginTop: 10 }}>
            <h3>เหตุผล</h3>
            <TextArea
              onChange={(e) => setRejectRemark(e.target.value)}
              placeholder="กรอกเหตุผลที่จะยกเลิก"
              autoSize={{ maxRows: 3, minRows: 3 }}
              style={{
                border: "1px solid #D9D9D9 !important",
                borderRadius: 10,
              }}
            />
          </div>
        )}
        <div style={{ width: "100%", display: "flex", gap: 10, marginTop: 20 }}>
          <Button
            danger={bookingToAcceptOrReject?.is_accept ? false : true}
            ghost={bookingToAcceptOrReject?.is_accept ? false : true}
            style={{
              width: "100%",
              backgroundColor: bookingToAcceptOrReject?.is_accept
                ? "green"
                : "#FF0000",
              color: "white",
            }}
            onClick={() => onAcceptOrRejectBooking()}
          >
            {bookingToAcceptOrReject?.is_accept ? "ยืนยัน" : "ปฏิเสธ"}
          </Button>
          {/* <Button
            onClick={() => {
              setIsAcceptOrReject(false);
              setBookingToAcceptOrReject(null);
              setRejectRemark(null);
            }}
            style={{ width: "100%" }}
            danger
            ghost
            type="primary"
          >
            ปิด
          </Button> */}
        </div>
      </Modal>
      <Modal
        onCancel={() => {
          setIsDelete(false);
          setDeleteData([]);
        }}
        open={isDelete}
        centered
        footer={false}
        closable={false}
      >
        <div style={{ fontSize: 42, color: "red", textAlign: "center" }}>
          <DeleteOutlined />
          <div style={{ fontSize: 28 }}>ลบประวัติการจอง</div>
        </div>
        <center>
          <div>หากทำการลบแล้วจะไม่สามารถกู้คืนกลับมาได้</div>
          <div
            style={{
              display: "flex",
              width: "100%",
              gap: 10,
              flexDirection: "column",
              marginTop: 10,
            }}
          >
            <Button
              style={{ width: "100%" }}
              type="primary"
              danger
              onClick={onConfirmDelete}
            >
              ลบ
            </Button>
            <Button
              style={{ width: "100%" }}
              onClick={() => {
                setIsDelete(false);
                setDeleteData([]);
              }}
            >
              ยกเลิก
            </Button>
          </div>
        </center>
      </Modal>

      <div className="job-header">
        <center>
          {userData?.user_type === 0 ? "งานของฉัน" : "การจองของฉัน"}
        </center>
        <center
          style={{
            fontSize: 14,
            fontWeight: "bold",
            marginTop: 0,
            color: "#777777",
          }}
        >
          {userData?.display_name}
          <div style={{ marginTop: 5 }}>
            {"รหัสสมาชิก"} : {userData?.code}
          </div>
        </center>
      </div>
      <div className="job-content">
        {(userData?.register_state === 3) | (userData?.register_state === 1) ? (
          <AlertError
            isClosed={isClosed}
            setIsClosed={setIsClosed}
            reject_reason={userData?.reject_reason}
            register_state={userData?.register_state}
          />
        ) : null}

        <div style={{ padding: 10, background: "white", borderRadius: 20 }}>
          <center>
            <h2 style={{ margin: 0 }}>
              รายการทั้งหมด{" "}
              <div style={{ fontSize: 14 }}>
                ({JOB_TYPE[menuActive][userData?.user_type]})
              </div>
            </h2>
          </center>
        </div>

        {userData?.user_type === 1 &&
          bookList["history"]?.length > 0 &&
          menuActiveKey === "history" && (
            <div
              onClick={() => onClickDelete(true)}
              style={{
                cursor: "pointer",
                padding: "10px 10px 0px 10px",
                marginBottom: -5,
                marginTop: 5,
                borderRadius: "10px",
                fontSize: 16,
                color: "red",
                width: "100%",
                textAlign: "center",
                textDecoration: "underline",
                textUnderlineOffset: 4,
              }}
            >
              <DeleteOutlined /> ลบประวัติการจองทั้งหมด
            </div>
          )}

        <Divider style={{ margin: "20px 0px 20px 0px" }} />
        {bookList &&
        Object?.keys(bookList)?.length > 0 &&
        userData.user_type === 0 ? (
          Object?.keys(bookList)?.map((key) => {
            return key === menuActiveKey ? (
              bookList[key].length > 0 ? (
                bookList[key].map((book, index) => {
                  if (book.status !== 0 || book.qr_expire) return <></>;
                  else
                    return (
                      <JobCard
                        job_index={index}
                        GetBookingList={GetBookingList}
                        setIsLoading={setIsLoading}
                        handeClickCancelJob={handeClickCancelJob}
                        calculateDeductMoney={calculateDeductMoney}
                        golfer_deduct_money={golfer_deduct_money}
                        setBookingToAcceptOrReject={setBookingToAcceptOrReject}
                        setIsAcceptOrReject={setIsAcceptOrReject}
                        onClickDelete={onClickDelete}
                        status_key={key}
                        booking={book}
                        userData={userData}
                      />
                    );
                })
              ) : (
                <></>
              )
            ) : (
              <></>
            );
          })
        ) : (
          <></>
        )}
        {bookList && Object?.keys(bookList)?.length > 0 ? (
          Object?.keys(bookList)?.map((key) => {
            return key === menuActiveKey ? (
              bookList[key].length > 0 ? (
                bookList[key].map((book, index) => {
                  if (userData.user_type === 0) {
                    if (book.status === 0 && !book.qr_expire)
                      return <Fragment />;
                    else
                      return (
                        <JobCard
                          job_index={index}
                          GetBookingList={GetBookingList}
                          setIsLoading={setIsLoading}
                          handeClickCancelJob={handeClickCancelJob}
                          calculateDeductMoney={calculateDeductMoney}
                          golfer_deduct_money={golfer_deduct_money}
                          setBookingToAcceptOrReject={
                            setBookingToAcceptOrReject
                          }
                          setIsAcceptOrReject={setIsAcceptOrReject}
                          onClickDelete={onClickDelete}
                          status_key={key}
                          booking={book}
                          userData={userData}
                        />
                      );
                  } else {
                    return (
                      <JobCard
                        job_index={index}
                        GetBookingList={GetBookingList}
                        setIsLoading={setIsLoading}
                        handeClickCancelJob={handeClickCancelJob}
                        calculateDeductMoney={calculateDeductMoney}
                        golfer_deduct_money={golfer_deduct_money}
                        setBookingToAcceptOrReject={setBookingToAcceptOrReject}
                        setIsAcceptOrReject={setIsAcceptOrReject}
                        onClickDelete={onClickDelete}
                        status_key={key}
                        booking={book}
                        userData={userData}
                      />
                    );
                  }
                })
              ) : (
                <div
                  style={{ background: "white", padding: 20, borderRadius: 20 }}
                >
                  <Empty
                    description={`ไม่พบข้อมูล${
                      JOB_TYPE[menuActive][userData?.user_type]
                    }`}
                  />
                </div>
              )
            ) : (
              <></>
            );
          })
        ) : (
          <div style={{ background: "white", padding: 20, borderRadius: 20 }}>
            <Empty description={`No ${JOB_TYPE[menuActive]} Job.`} />
          </div>
        )}
      </div>
      <FooterMenu
        onChangePage={onChangePage}
        menuActive={menuActive}
        userType={userData?.user_type}
      />
    </div>
  );
}
